/* unplugin-vue-components disabled */
import AddTracker from './add-tracker.vue'
import {stringToFile} from 'utils/utils'
import {Column, TableScrollable} from 'components/data-table'
import $companies from 'stores/companies'
import $contacts2 from 'stores/contacts2'
import $topics2 from 'stores/topics2'

export default {
  components: {TableScrollable, Column, AddTracker},
  props: {
    widget: {type: Object, required: true},
    expanded: {type: Boolean, default: false}
  },
  emits: ['expand', 'collapse'],
  data() {
    return {
      saving_idx: false,
    }
  },
  computed: {
    user_id_field() {
      return {
        tracker_companies: 'user_company_id',
        tracker_contacts: 'user_contact_id',
        tracker_topics: 'user_topic_id',
      }[this.widget.type]
    },
    entities() {
      return this.widget.entities || []
    },
    rows() {
      return this.entities.map((entity, index) => ({entity, index}))
    },
    available() {
      return this.entities.filter(el => !el[this.user_id_field])
    },
    title(){
      if (this.available.length) {
        return `${this.widget.title} (${this.available.length})`
      }
      return this.widget.title
    },
  },
  methods: {
    prepareDomNode() {
      const table = this.$refs.table.$el.querySelector('table')
      if (!table) return
      const dom = table.cloneNode(true)
      dom.querySelectorAll('.action').forEach(cell => cell.remove())
      return dom
    },
    async copyText() {
      const table = this.prepareDomNode()
      if (!table) return
      await $utils.copyText($utils.dom.domTableToText(table))
      $utils.toasts.success('Table copied to clipboard')
    },
    downloadCSV() {
      const table = this.prepareDomNode()
      if (!table) return
      stringToFile(
        $utils.dom.domTableToCsv(table),
        this.widget.title ? `${$utils.str.truncate(this.widget.title, 50)}.csv` : 'table.csv',
        'data:text/csv;charset=utf-8'
      )
      $utils.toasts.success('Table downloaded')
    },
    async addOne(entity, idx) {
      this.saving_idx = idx
      try {
        switch (this.widget.type) {
          case 'tracker_companies':
            await this.addCompany(entity)
            break
          case 'tracker_contacts':
            await this.addContact(entity)
            break
          case 'tracker_topics':
            await this.addTopic(entity)
            break
        }
      } finally {
        this.saving_idx = null
      }
    },
    async addCompany(entity) {
      try {
        const company = await $companies.newCompany({
          linkedin_id: entity.linkedin_id,
          shared_company_id: entity.shared_company_id,
          company_name: entity.name,
        })

        entity.user_company_id = company.id
        entity.shared_company_id = company.shared_company_id
        entity.image_url = company.logo_url
      } catch (err) {
        if (err.http_code === 461) {
          $utils.toasts.success('It seems that this company does not exist. Please try again.')
          return
        }
        throw err
      }
    },
    async addContact(entity) {
      try {
        const contact = await $contacts2.newContact({
          linkedin_id: entity.linkedin_id,
          shared_contact_id: entity.shared_contact_id,
          shared_company_id: entity.shared_company_id,
          company_linkedin_id: entity.company_linkedin_id,
          company_name: entity.company_name,
        })

        entity.user_contact_id = contact.id
        entity.shared_contact_id = contact.shared_contact_id
        entity.image_url = contact.avatar_url
      } catch (err) {
        if (!err.http_code) throw err
        if (err.http_code === 461) {
          $utils.toasts.error('It seems that this person does not exist. Please try again.')
          return
        }
        $utils.toasts.error(`Failed to follow person: ${err}`)
      }
    },
    async addTopic(entity) {
      try {
        const topic = await $topics2.newTopic({
          name: entity.name,
          shared_topic_id: entity.shared_topic_id,
          tracker_focus: 'balanced',
          tracker_alerts: 'all',
          focus_on: '',
        })

        entity.user_topic_id = topic.id
        entity.shared_topic_id = topic.shared_topic_id
      } catch (err) {
        $utils.toasts.error('Failed to track this topic. Please try again.')
      }
    }
  }
}
